import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useSelector } from "react-redux";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useAppDispatch } from "../Core/store.hooks";
import {
    TabStrip,
    TabStripTab,
    GridLayout,
    GridLayoutItem,
    Card,
    CardTitle,
    CardImage,
} from "@progress/kendo-react-layout";

import {
    Menu,
    MenuItem,
    MenuSelectEvent,
    MenuItemLink,
} from "@progress/kendo-react-layout";
type handler = () => void;
interface externalNavProps {
    selectedRoute: string;
    params: any;
}
const ExternalNav = (props: externalNavProps) => {
    const [colWidth, setColWidth] = React.useState(180);

    const backgroundMenuBig = {
        backgroundColor: "#1a171b",
        color: "white",
        fontSize: "1.1rem",
        padding: "2px",
        borderRight: "1px solid #454347"
    };
    const backgroundMenuBig1 = {
        backgroundColor: "#1a171b",
        color: "#4fb9ff",
        fontSize: "1.1rem",
        padding: "2px",
        borderRight: "1px solid #454347"
    };
    const onSelect = (event: MenuSelectEvent) => {
        openLink(event.item.data.name)
    };
    const openLink = (linkName) => {
        let params = "/";

        if (linkName == "home") {
            window.open(
                "https://fleetmgmt.powerplatform.net/search",
                "_self"
            );
        }
        else if (linkName == "serviceView") {
            window.open(
                "https://fleetmgmt.powerplatform.net/jiraReports" ,
                "_self"
            );
        }
        else if (linkName == "user") {
            window.open(
                "https://fleetmgmt.powerplatform.net/default.aspx#/users",
                "_self"
            );
        } else if (linkName == "machineData") {

            const customer = props.params.customerID;
            if (props.params.mainMachineSerialNo != null) {
                params = "/customerid=" +
                    customer +
                    "&mainMachineSerialNo=" +
                    props.params.mainMachineSerialNo;

            }
            else if (customer != null) {
                params = "/customerid=" + customer;

            }
            window.open(
                "https://machinedata.powerplatform.net" + params,
                "_self"
            );
        }


    };
    return (
        <Menu onSelect={onSelect} vertical={false} >
            <MenuItem
                text="Home"
                data={{ name: "home" }}
                cssStyle={backgroundMenuBig}
            />
            <MenuItem
                text="Service Tools"
                data={{ name:"serviceView" }}
                cssStyle={backgroundMenuBig}
            />
            <MenuItem
                text="Machine Analytics"
                data={{name:"machineData"} }
                cssStyle={backgroundMenuBig}
            />
            <MenuItem
                text="Global Analytics"
                data={{ name:"globalView" }}
                cssStyle={backgroundMenuBig1}
            />


        </Menu>
       )
};

export default ExternalNav;
